import * as React from "react";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";

export default function BenefitsCard() {
  return (
    <Box
      sx={{
        width: {xs:"90%", md: "70%"},
        height: "fit-content",
        textAlign: "center",
        // margin: "auto",
        margin: { xs: "2rem auto", md: "0rem auto 6rem" },
        backgroundColor: 'primary.dark',
        // background:
        //   "linear-gradient(135deg, #f4f9ff30 0%, rgba(255, 255, 255, 0) 70%), linear-gradient(45deg, #ffffff 0%, #f4f9ff30 100%)",
        // backdropFilter: "blur(20px)",
        // background: "linear-gradient(0deg, rgba(244, 249, 255, 0) 0%, #F4F9FF 100%)",
        borderRadius: "20px",
        boxShadow: "0 8px 32px 0 rgb(59 72 255 / 11%)",
      }}
    >
      <Box
        sx={{
          height: "inherit",
          textAlign: "center",
          margin: "auto",
          // backgroundColor: "#cbe4de33",
          color: "black",
          borderRadius: "10px",
          padding: {xs:"1rem 0rem", md: "3rem 2rem"},
        }}
      >
        <Box sx={{display:"flex", justifyContent: "space-evenly",  flexDirection: "row", flexWrap: "wrap"}}>
        <Box sx={{width:"8rem", backgroundColor: "#fff1", height: "8rem", m:1, p:1, borderRadius: "12px"}}>
            <Typography sx={{color: "white", transform: "translateY(0.8rem)"}}>
            <span style={{fontSize: "2rem", fontWeight: "600"}}>28%+</span><br/> Increase in conversions
            </Typography>
          </Box>
          <Box sx={{width:"8rem", backgroundColor: "#fff1", height: "8rem", m:1, p:1, borderRadius: "12px"}}>
            <Typography sx={{color: "white", transform: "translateY(0.8rem)"}}>
            <span style={{fontSize: "2rem", fontWeight: "600"}}>50%+</span><br/> Increase in pre-paid orders
            </Typography>
          </Box>
          <Box sx={{width:"8rem", backgroundColor: "#fff1", height: "8rem", m:1, p:1, borderRadius: "12px"}}>
            <Typography sx={{color: "white", transform: "translateY(0.8rem)", }}>
            <span style={{fontSize: "2rem", fontWeight: "600"}}>30%</span><br/> Reduction in RTO
            </Typography>
          </Box>
          <Box sx={{width:"8rem", backgroundColor: "#fff1", height: "8rem", m:1, p:1, borderRadius: "12px"}}>
            <Typography sx={{color: "white", transform: "translateY(0.8rem)"}}>
            <span style={{fontSize: "2rem", fontWeight: "600"}}>35%</span><br/> Increase in repeat purchases
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
